import { registerTourPage } from '@/composables/tour/tourRegistry';
import { introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-my-account', {
  key: 'admin-my-account',
  label: 'My Account',
  getSteps: () => [
    introStep({
      title: 'Your Account',
      content:
        '"My Roles & Permissions" lists what you can do in this school and lets you request additional roles. "Profile & Security" is where you update your personal info and change your password.',
    }),
  ],
});

registerTourPage('admin-invited-staff', {
  key: 'admin-invited-staff',
  label: 'Invited Staff',
  getSteps: () => [
    introStep({
      title: 'Pending Invitations',
      content:
        'Staff you\'ve invited but haven\'t accepted yet. From here you can resend the email, copy the invite link, or revoke an invitation that should no longer be valid.',
    }),
  ],
});

registerTourPage('StudentOverview', {
  key: 'admin-student-overview',
  label: 'Student Overview',
  getSteps: () => [
    introStep({
      title: 'Full Student Profile',
      content:
        'Personal info, classroom assignment, courses or subjects, attendance, bills, and (for tertiary) results. The "Reset Password" button up top lets you generate a new password if a student is locked out.',
    }),
  ],
});
